import React from 'react';
import { getItem, setItem } from 'src/helpers/session';

class Component extends React.Component {
  state = {
    statsScale: getItem('statsScale') || 1
  };

  componentDidMount() {
    console.log('componentDidMount');
  }

  onChange = e => {
    let { name, value } = e.target;
    this.setState({ [name]: value });
    setItem(name, value);
  };

  formGroup = params => {
    let { label, key, placeholder, options, type, onChange, onBlur } = params;
    let value = params.value || this.props.data[key] || '';
    return (
      <div class='form-group row'>
        <label class='col-3 col-form-label'>{label}</label>
        <div class='col-9'>
          {!options && (
            <input
              class='form-control'
              type={type || 'text'}
              placeholder={placeholder ? placeholder : label}
              name={key}
              value={value}
              onChange={onChange || this.onChange}
              onBlur={onBlur || this.onBlur}
            />
          )}
          {options && (
            <select name={key} value={value} class='form-control' onChange={this.onBlur}>
              {Object.keys(options).map(key => (
                <option key={key} value={key}>
                  {options[key]}
                </option>
              ))}
            </select>
          )}
        </div>
      </div>
    );
  };

  render() {
    let fg = this.formGroup;
    return (
      <div>
        <div class='box'>
          <div class='box-body'>
            {fg({ label: 'Scale', key: 'statsScale', type: 'number', value: this.state.statsScale })}
          </div>
        </div>
      </div>
    );
  }
}

import api from '../actions/api';
import setState from '../actions/state';
import { connect } from 'react-redux';

export default connect(
  function(state) {
    let apiState = state.api.config_load || state.api.initial;
    let editApiState = state.api.config_edit || state.api.initial;
    return {
      ...apiState.data,
      initial: apiState.initial,
      loading: apiState.loading,
      data: apiState.data,
      editLoading: editApiState.loading,
      state: state.state.config || state.state.initial,
      user: state.session.user
    };
  },
  {
    api,
    setState: setState('config')
  }
)(Component);
